import { createUseQuery } from 'api/common/createUseQuery'
import { fetchJobFamily, JobFamily } from 'api/fetchers/filters/fetchJobFamily'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useJobFamily = createUseQuery({
  queryKey: ApiQueryKeys.JOB_FAMILY_GROUPS,
  fetcher: fetchJobFamily,
  selector: res => (res?.data as JobFamily[] | undefined) ?? ([] as JobFamily[]),
})
